<template>
  <div class="snackBar like" v-if="show">
    <div class="snackBarContent">
      <div class="message">
        ログインしていただくとアプリや他の端末とお気に入り情報が共有できます。
      </div>
      <div class="action" @click="closeSnackBar">
        閉じる
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false
  }),
  computed: {
    getSignupAppeal() {
      return this.$store.getters['like/getSignupAppeal'];
    }
  },
  watch: {
    getSignupAppeal(val) {
      if (val) {
        this.$store.dispatch('like/setSignupAppeal', false);
        this.show = true;
      }
    }
  },
  methods: {
    closeSnackBar() {
      this.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.snackBar.like {
  z-index: 10000;
}
</style>
